
import {defineComponent} from 'vue';
// import clickOutsideDirective from '@/directives/click-outside';
import clickOutsideDirective from '../../util/theme_directives/click-outside';


export default defineComponent({
  name: 'OxdDropdownMenu',

  directives: {
    'click-outside': clickOutsideDirective,
  },

  emits: ['dropdown:opened', 'dropdown:closed'],

  data() {
    return {
      isActive: false,
    };
  },

  methods: {
    openSubmenu() {
      this.isActive = true;
      this.$emit('dropdown:opened');
    },
    closeSubMenu() {
      if (this.isActive) {
        this.isActive = false;
        this.$emit('dropdown:closed');
      }
    },
  },
});
